import React from "react"
import { Button } from "@/components/ui/button"
import { User } from "lucide-react"
import { StoreSearch } from "./StoreSearch"

interface TopBarProps {
    onAccountClick: () => void
    accountButtonRef?: React.RefObject<HTMLButtonElement>
}

export function TopBar({ onAccountClick, accountButtonRef }: TopBarProps) {
    return (
        <div className="border-b bg-white p-4 flex items-center justify-between">
            <div className="flex items-center space-x-2 w-full max-w-md">
                <StoreSearch />
            </div>
            <Button variant="ghost" size="icon" onClick={onAccountClick} className="ml-auto" ref={accountButtonRef}>
                <User className="h-6 w-6" />
            </Button>
        </div>
    )
}
